import { ERC20 as ERC20Abi, ZkToken as ZkTokenAbi } from '../abis';
import { executeTx, getContract } from '../utils';
export class ZkToken {
    constructor(options) {
        this.options = options;
        this.ybTokenContract = this.createYbTokenContract();
        this.zkTokenContract = this.createZkTokenContract();
    }
    async mint(amount) {
        const amountBigInt = amount.shl(this.options.ybTokenDecimals).quotient;
        const allowance = await this.ybTokenContract.allowance(this.options.ownerAddress, this.options.zkTokenAddress);
        if (allowance < amountBigInt) {
            const approveTx = this.ybTokenContract.approve(this.options.zkTokenAddress, amountBigInt);
            await executeTx(approveTx);
        }
        const mintTx = this.zkTokenContract.mint(this.options.ownerAddress, amountBigInt);
        return await executeTx(mintTx);
    }
    async unwrap(amount) {
        const amountBigInt = amount.shl(this.options.zkTokenDecimals).quotient;
        const burnTx = this.zkTokenContract.redeem(this.options.ownerAddress, amountBigInt);
        return await executeTx(burnTx);
    }
    createZkTokenContract() {
        return getContract(this.options.zkTokenAddress, ZkTokenAbi, this.options.rpcSigner);
    }
    createYbTokenContract() {
        return getContract(this.options.ybTokenAddress, ERC20Abi, this.options.rpcSigner);
    }
}
